import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { SMALL_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    swiperWrapper: {
      '& .swiper-button-next, & .swiper-button-prev': {
        top: '41%',
      },
    },
    chunkWrapper: {
      position: 'relative',
      display: 'flex',
      flexWrap: 'wrap',
    },
    chunk: {
      width: `calc(50% - ${SMALL_MARGIN / 2}px)`,
      height: 255,
      marginBottom: SMALL_MARGIN,
      '& > div': {
        height: 255,
      },
      '&:nth-child(2n + 1)': {
        marginRight: SMALL_MARGIN,
      },
      [theme.breakpoints.up('sm')]: {
        width: `calc((100% - ${2 * SMALL_MARGIN}px)/3)`,
        '&:nth-child(2n + 1)': {
          marginRight: 0,
        },
        '&:nth-child(3n + 2)': {
          marginRight: SMALL_MARGIN,
        },
        '&:nth-child(3n + 1)': {
          marginRight: SMALL_MARGIN,
        },
      },
    },
    expertItem: {},
    expertsWrapper: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      columnGap: SMALL_MARGIN,
    },
    expertsItem: {
      position: 'relative',
      paddingBottom: SMALL_MARGIN,
      '&:before': {
        content: '""',
        display: 'block',
        width: '100%',
        paddingTop: '100%',
      },
      '& > div, & > a': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: `calc(100% - ${SMALL_MARGIN}px)`,
      },
    },
  }),
);

export default useStyles;
